import { API, setAuthToken } from '../../../config/API.js';
import { GET_FILE_GCG, SET_LOADING_FILE_GCG, SET_PAGINATION_FILE_GCG } from '../constant.js';

export const getFileGCG = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_FILE_GCG,
      payload: true,
    });
    API.get(`admin/gcg/file?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_FILE_GCG,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_FILE_GCG,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_FILE_GCG,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_FILE_GCG,
          payload: 0,
        });
      });
  };
};

export const addFileGCG = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/gcg/file/add", params);
};

export const updFileGCG = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/gcg/file/edit", params);
};

export const delFileGCG = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/gcg/file/delete/" + code);
};
